export class Questionnaire {
    private id: String;
    private name: String;
    private title: String;
    private description: String;
    private origin: String;
    private is_active: Boolean;
    private can_use = [];
    private is_onetime: Boolean;
    private is_multiple: Boolean;
    private is_filledout: Boolean = false;
    private schedule = [];
    private isScheduleChangeable: Boolean;
    private introtext: String;
    private outrotext: String;

    constructor(id: String) {
        this.id = id;
    }

    public setId(id: String) { this.id = id; }
    public getId() { return this.id; }
    public setName(name: String) { this.name = name; }
    public getName() { return this.name; }
    public setTitle(title: String) { this.title = title; }
    public getTitle() { return this.title; }
    public setDescription(desc: String) { this.description = desc; }
    public getDescription() { return this.description; }
    public setOrigin(origin: String) { this.origin = origin; }
    public getOrigin() { return this.origin; }
    public setActive(active: Boolean) { this.is_active = active; }
    public isActive() { return this.is_active; }
    public setCanUse(can_use) { this.can_use = can_use; }
    public getCanUse() { return this.can_use; }
    public setOneTime(onetime: Boolean) { this.is_onetime = onetime; }
    public isOneTime() { return this.is_onetime; }
    public setMultiple(multiple: Boolean) { this.is_multiple = multiple; }
    public isMultiple() { return this.is_multiple; }
    public setFilledOut(filledout: Boolean) { this.is_filledout = filledout }
    public isFilledOut() { return this.is_filledout; }
    public setSchedule(schedule) { this.schedule = schedule; }
    public getSchedule() { return this.schedule; }
    public setScheduleChangeable(change: Boolean) { this.isScheduleChangeable = change; }
    public scheduleChangeable() { return this.isScheduleChangeable; }
    public setIntrotext(intro: String) { this.introtext = intro; }
    public getIntrotext() { return this.introtext; }
    public setOutrotext(outro: String) { this.outrotext = outro; }
    public getOutrotext() { return this.outrotext; }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/questionnaire.ts